document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('.product-info__buy-buttons > form');

  const brandSelect = document.querySelector('#brand-select');
  const brandInput = document.querySelector('#brand-input');

  const modelSelects = document.querySelectorAll('#model-select');
  const modelInput = document.querySelector('#model-input');

  const propertySelects = document.querySelectorAll('.property-select');

  const yearSelect = document.querySelector('#year-select');
  const yearInput = document.querySelector('#year-input');

  if (form) {
    const formId = form.getAttribute("id");

    brandSelect.setAttribute("form", formId);
    brandSelect.required = true;

    modelSelects.forEach(el => {
      el.setAttribute("form", formId);
      el.required = true;
    });

    yearSelect.setAttribute("form", formId);
    yearSelect.required = true;
  }

  if (brandSelect) {
    brandSelect.addEventListener('change', () => {
      let selectedCarMake = brandSelect.value;
      if (brandInput) {
        brandInput.value = selectedCarMake;
      }
      if (propertySelects) {
        propertySelects.forEach(element => {
          element.classList.remove('active');
          let selectElem = element.querySelector("select");
          DisableSelect(selectElem);
        });
      }
      let modelSelect = document.querySelector(`#model-${selectedCarMake}`);
      if (modelSelect) {
        let modelOptions = modelSelect.querySelectorAll('option');
        modelOptions[0].selected = true;
        modelSelect.classList.add('active');
        let selectElem = modelSelect.querySelector("select");
        EnableSelect(selectElem);
      }
    });
  }

  if (modelSelects) {
    modelSelects.forEach(modelSelect => {
      modelSelect.addEventListener('change', () => {
        let selectedCarModel = modelSelect.value;
        if (modelInput) {
          modelInput.value = selectedCarModel;
        }
      });
    });
  }

  if (yearSelect) {
    yearSelect.addEventListener('change', () => {
      let selectedCarYear = yearSelect.value;
      if (yearInput) {
        yearInput.value = selectedCarYear;
      }
    });
  }

  function EnableSelect(selectElem) {
    selectElem.removeAttribute("disabled");
    selectElem.setAttribute("required", "required");
  }

  function DisableSelect(selectElem) {
    selectElem.setAttribute("disabled", "disabled");
    selectElem.removeAttribute("required");
  }

  // localStorage-based selection persistence
  const brandSelection = document.querySelector('#brand-select');
  const modelSelections = document.querySelectorAll('#model-select');
  const yearSelection = document.querySelector('#year-select');

  const BRAND_SELECTION_NAME = "selectedBrand";
  const MODEL_SELECTION_NAME = "selectedModel";
  const YEAR_SELECTION_NAME = "selectedYear";

  function getStored(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function setStored(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {}
  }

  if (brandSelection) {
    brandSelection.addEventListener('change', () => {
      setStored(BRAND_SELECTION_NAME, brandSelection.value);
    });

    let cachedBrand = getStored(BRAND_SELECTION_NAME);
    if (cachedBrand) {
      brandSelection.value = cachedBrand;
      brandSelection.dispatchEvent(new Event("change"));

      let cachedModel = getStored(MODEL_SELECTION_NAME);
      if (cachedModel) {
        let currentModelSelection = document.querySelector(".property-select.active select");
        if (currentModelSelection) {
          let currentModelSelectionOptions = currentModelSelection.querySelectorAll("option");
          currentModelSelectionOptions.forEach(option => {
            if (option.value == cachedModel) {
              currentModelSelection.value = cachedModel;
              currentModelSelection.dispatchEvent(new Event("change"));
            }
          });
        }
      }
    }
  }

  if (modelSelections) {
    modelSelections.forEach(selection => {
      selection.addEventListener('change', () => {
        setStored(MODEL_SELECTION_NAME, selection.value);
      });
    });
  }

  if (yearSelection) {
    yearSelection.addEventListener('change', () => {
      setStored(YEAR_SELECTION_NAME, yearSelection.value);
    });

    let cachedYear = getStored(YEAR_SELECTION_NAME);
    if (cachedYear) {
      yearSelection.value = cachedYear;
      yearSelection.dispatchEvent(new Event("change"));
    }
  }

  // Variant option localStorage persistence
  var VARIANT_OPTIONS_KEY = 'selectedVariantOptions';

  function saveVariantOptions() {
    var allOptions = {};
    document.querySelectorAll('select[name^="option"], input[type="radio"][name^="option"]:checked').forEach(function(el) {
      allOptions[el.name] = el.value;
    });
    try { localStorage.setItem(VARIANT_OPTIONS_KEY, JSON.stringify(allOptions)); } catch (e) {}
  }

  function restoreVariantOptions() {
    var saved;
    try { saved = localStorage.getItem(VARIANT_OPTIONS_KEY); } catch (e) { return; }
    if (!saved) return;

    try {
      var options = JSON.parse(saved);
      Object.keys(options).forEach(function(name) {
        var value = options[name];

        var select = document.querySelector('select[name="' + name + '"]');
        if (select && select.value !== value) {
          var hasOption = Array.from(select.options).some(function(o) { return o.value === value; });
          if (hasOption) {
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        var radio = document.querySelector('input[type="radio"][name="' + name + '"][value="' + CSS.escape(value) + '"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    } catch (e) {}
  }

  // Listen for variant option changes on all option selectors
  document.querySelectorAll('[data-option-selector]').forEach(function(selector) {
    selector.addEventListener('change', saveVariantOptions);
  });

  // Restore saved options after VariantPicker initializes
  var productForm = document.querySelector('form[is="product-form"]');
  if (productForm) {
    var restored = false;
    function doRestore() {
      if (restored) return;
      restored = true;
      restoreVariantOptions();
    }
    productForm.addEventListener('variant:change', doRestore, { once: true });
    setTimeout(doRestore, 1500);
  }
});
